<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :vendedores="enableVendedores"
          :receitas="enableReceita"
          :redes="enableRede"
          :categorias="enableCategoria"
          :promotores="enablePromotor"
          :url="link"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'100'"
                    :text="'Faturamento'"
                    :texto-information="textoFaturamento"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteFaturamentoAtual" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'342'"
                    :text="'Devolução'"
                    :texto-information="textoDevolucao"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="devolucao"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingDevolucao"
                    style="margin: -1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteMetaAtual" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'101'"
                    :text="'Meta'"
                    :texto-information="textoMeta"
                    :style-object="styleObjectMeta"
                    :componente-valor="true"
                    :valor="meta"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingMeta"
                    style="margin: 0.1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteMetaAtual" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'102'"
                    :text="'Meta Mensal'"
                    :texto-information="textoMetaMensal"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart2'"
                    :title="titleChartMeta"
                    :dados-grafico="chartMeta"
                    :titulo-id="'titulo2'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco1"
                    :loading="loadingGraficoMeta"
                    style="margin: 0.1rem 0 0 0"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-container>
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :code-information="'103'"
                  :text="'Comparativo Fat. x Meta'"
                  :texto-information="textoFaturamentoMeta"
                  :style-object="styleObject"
                  :componente-grafico="true"
                  :grafico-id="'myChart'"
                  :dados-grafico="chartBarLinha"
                  :titulo-id="'myChart'"
                  :legenda-grafico="legendaGrafico"
                  :exibir-legenda="true"
                  :padding="dynamicPaddingBloco2"
                  :loading="loadingFaturamentoxMeta"
                  style="margin: 3rem 0 0 0"
                />
              </v-container>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'104'"
                    :text="'Fat. mês anterior'"
                    :texto-information="textoFaturamentoAnterior"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoMesAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingFaturamentoAnterior"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'343'"
                    :text="'Devolução Mês Anterior'"
                    :texto-information="textoDevolucaoAnterior"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="valorDevolucaoMesAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingDevolucaoAnterior"
                    style="margin: -1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'105'"
                    :text="'Mês Anterior'"
                    :texto-information="textoFatxFatAnterior"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart3'"
                    :title="titleChartFatxFatAnterior"
                    :dados-grafico="chartFatxFatAnterior"
                    :titulo-id="'titulo3'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingGraficoCompFatAnterior"
                    style="margin: -0.1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteFatMesAnotAnterior" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'106'"
                    :text="'Fat. do Mês do Ano Anterior'"
                    :texto-information="textoFaturamentoAnoAnterior"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamentoMesAnoAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingFatAnoAnterior"
                    style="margin: -0.1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteFatMesAnotAnterior" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'344'"
                    :text="'Devolução Mês do Ano Anterior'"
                    :texto-information="textoDevolucaoAnoAnterior"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="valorDevolucaoMesAnoAnterior"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingDevAnoAnterior"
                    style="margin: -0.1rem 0 0 0"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <!-- id="componenteFatMesAnotAnterior" -->
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'107'"
                    :text="'Mês do Ano Anterior'"
                    :texto-information="textoFatxFatAnoAnterior"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart4'"
                    :title="titleChartFatxFatAnoAnterior"
                    :dados-grafico="chartFatxFatAnoAnterior"
                    :titulo-id="'titulo4'"
                    :exibir-titulo-grafico="true"
                    :padding="dynamicPaddingBloco3"
                    :loading="loadingGraficoCompFatAnoAnterior"
                    style="margin: -0.1rem 0 0 0"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-divider
          id="dividerBloco1"
          class="mb-5"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'108'"
                    :text="'E quanto falta para atingirmos?'"
                    :texto-information="textoAtigimento"
                    :style-object="styleObject"
                    :componente-grafico="true"
                    :grafico-id="'myChart5'"
                    :grafico-id2="'myChart6'"
                    :dados-grafico="chartValorMonetario"
                    :lengenda-valor-moterio="true"
                    :valor-exibicao="valorExibicao"
                    :valor-restante="valorRestante"
                    :dados-grafico2="chartValorMonetarioDiario"
                    :enable-grafico-valor-monetario="true"
                    :padding="dynamicPaddingBloco4"
                    :loading="loadingGraficoValorMonetarioDiario"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'109'"
                    :text="'Qual a tendência de faturamento?'"
                    :texto-information="textoTendencia"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorTedenciaFaturamento"
                    :padding="dynamicPaddingBloco5"
                    :loading="loadingValorTendenciaFaturamento"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'110'"
                    :text="'Qual a quantidade de dias úteis no mês?'"
                    :texto-information="textoDiasUteis"
                    :style-object="styleObject"
                    :componente-dias-uteis="true"
                    :dias-uteis="diasUteis"
                    :dias-pecorrido="diasPecorrido"
                    :padding="dynamicPaddingBloco5"
                    :loading="loadingDiasPercorrido"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'111'"
                    :text="'E minha carteira de pedidos?'"
                    :texto-information="textoPedidos"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorPedidos"
                    :padding="dynamicPaddingBloco6"
                    :loading="loadingValorPedidos"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'112'"
                    :text="'E quanto está minha volumetria?'"
                    :texto-information="textoVolume"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="`${valorVolume} Kg`"
                    :padding="dynamicPaddingBloco6"
                    :loading="loadingVolume"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import eventEmit from '../../components/core/EventoEmit'
  import Comercial from '../../../../services/comercial'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  // REGISTRA O PLUGIN GRAFICO DOUGHNUT APENAS UMA VEZ
  const pluginComercial = {
    id: 'centerText',
    beforeDraw (chart) {
      const centerConfig = chart.config.options.elements?.center
      if (!centerConfig) return

      const ctx = chart.chart.ctx
      const txt = centerConfig.text
      const fontStyle = centerConfig.fontStyle || 'Arial'
      const color = centerConfig.color || '#000'

      const width = chart.chartArea.right - chart.chartArea.left
      const height = chart.chartArea.bottom - chart.chartArea.top

      const fontSize = Math.min(width, height) / 5

      ctx.save()
      ctx.font = `${fontStyle} ${fontSize}px Arial`
      ctx.fillStyle = color
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'

      const centerX =
        (chart.chartArea.left + chart.chartArea.right) / 2
      const centerY =
        (chart.chartArea.top + chart.chartArea.bottom + 130) / 2

      ctx.fillText(txt, centerX, centerY)
      ctx.restore()
    },
  }

  export default {
    name: 'PageComercial',
    emits: ['updateDatas', 'setDados', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectCarteiraPedidos: {
        color: '#9d9ac5',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisores: [],
      vendedores: [],
      receita: [],
      rede: [],
      categoria: [],
      promotor: [],
      codigo: 0,
      textoFaturamento: '',
      textoMeta: '',
      textoMetaMensal: '',
      textoFaturamentoMeta: '',
      textoFaturamentoAnterior: '',
      textoFatxFatAnterior: '',
      textoFaturamentoAnoAnterior: '',
      textoFatxFatAnoAnterior: '',
      textoAtigimento: '',
      textoTendencia: '',
      textoDiasUteis: '',
      textoPedidos: '',
      textoVolume: '',
      textoDevolucao: '',
      textoDevolucaoAnterior: '',
      textoDevolucaoAnoAnterior: '',
      orientacao: [],
      codigoIds: ['100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '110', '111', '112', '342', '343', '344'],
      permissaoGestaoComercial: '',
      activeHover: false,
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableVendedores: true,
      enableReceita: true,
      enableRede: true,
      enablePromotor: true,
      enableCategoria: true,
      devolucaoImpropria: 0,
      porcentagemImpropria: 0,
      devImpropriaEnable: false,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      devolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      meta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartMeta: {},
      titleChartMeta: '',
      legendaGrafico: [],
      chartBarLinha: {},
      valorFaturamentoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      titleChartFatxFatAnterior: '',
      chartFatxFatAnterior: {},
      valorFaturamentoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartFatxFatAnoAnterior: {},
      titleChartFatxFatAnoAnterior: '',
      chartValorMonetario: {},
      chartValorMonetarioDiario: {},
      valorRestante: '',
      valorExibicao: '',
      valorRestante2: '',
      valorExibicao2: '',
      valorTedenciaFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      diasUteis: '0',
      diasPecorrido: '0',
      valorPedidos: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorVolume: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      dynamicPaddingBloco1: '',
      dynamicPaddingBloco2: '',
      dynamicPaddingBloco3: '',
      dynamicPaddingBloco4: '',
      dynamicPaddingBloco5: '',
      dynamicPaddingBloco6: '',
      loadingFaturamento: false,
      loadingDevolucao: false,
      loadingMeta: false,
      loadingGraficoMeta: false,
      loadingFaturamentoxMeta: false,
      loadingFaturamentoAnterior: false,
      loadingDevolucaoAnterior: false,
      loadingGraficoCompFatAnterior: false,
      loadingFatAnoAnterior: false,
      loadingDevAnoAnterior: false,
      loadingGraficoCompFatAnoAnterior: false,
      loadingGraficoValorMonetarioDiario: false,
      loadingValorTendenciaFaturamento: false,
      loadingDiasPercorrido: false,
      loadingValorPedidos: false,
      loadingVolume: false,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)

      Chart.plugins.unregister(pluginComercial)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        Chart.plugins.register(pluginComercial)

        eventEmit.$emit('atualizar_texto', 'Gestão Comercial')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 14rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 42rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 10rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 21rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 18rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 21rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 10rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 30rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 6rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 10rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 7rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 8rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco1 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 12rem !important'
        } else {
          this.dynamicPaddingBloco1 = 'padding-right: 7rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 25rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 1rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 3rem !important'

          this.dynamicPaddingBloco5 = 'padding-right: 3rem !important'

          this.dynamicPaddingBloco6 = 'padding-right: 3rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisores = supervisores
        this.vendedores = vendedores
        this.receita = receita
        this.rede = redes
        this.categoria = categoria
        this.promotor = promotor

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', primeiroDia)
        localStorage.setItem('dataFinal', dataFinal)

        this.atualizaDados()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      updateDate () {
        eventEmit.$emit('update-datas', this.primeiroDia, this.date, this.select, this.supervisores, this.receita, this.vendedores, this.rede, this.categoria, this.promotor)
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '100') {
            this.textoFaturamento = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '101') {
            this.textoMeta = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '102') {
            this.textoMetaMensal = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '103') {
            this.textoFaturamentoMeta = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '104') {
            this.textoFaturamentoAnterior = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '105') {
            this.textoFatxFatAnterior = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '106') {
            this.textoFaturamentoAnoAnterior = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '107') {
            this.textoFatxFatAnoAnterior = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '108') {
            this.textoAtigimento = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '109') {
            this.textoTendencia = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '110') {
            this.textoDiasUteis = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '111') {
            this.textoPedidos = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '112') {
            this.textoVolume = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '342') {
            this.textoDevolucao = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '343') {
            this.textoDevolucaoAnterior = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '344') {
            this.textoDevolucaoAnoAnterior = this.orientacao[i].descricao
          }
        }
      },

      async atualizaDados () {
        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.devolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoMesAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorTedenciaFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.diasUteis = '0'
        this.diasPecorrido = '0'
        this.valorPedidos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorVolume = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.titleChartMeta = ''
        this.titleChartFatxFatAnterior = ''
        this.titleChartFatxFatAnoAnterior = ''
        this.valorRestante = ''
        this.valorExibicao = ''
        this.valorRestante2 = ''
        this.valorExibicao2 = ''

        if (this.chartMeta.data) {
          this.chartMeta.destroy()
        }

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        if (this.chartFatxFatAnterior.data) {
          this.chartFatxFatAnterior.destroy()
        }

        if (this.chartFatxFatAnoAnterior.data) {
          this.chartFatxFatAnoAnterior.destroy()
        }

        if (this.chartValorMonetario.data) {
          this.chartValorMonetario.destroy()
        }

        if (this.chartValorMonetarioDiario.data) {
          this.chartValorMonetarioDiario.destroy()
        }

        this.loadingFaturamento = true
        this.loadingDevolucao = true
        this.loadingMeta = true
        this.loadingGraficoMeta = true
        this.loadingFaturamentoxMeta = true
        this.loadingFaturamentoAnterior = true
        this.loadingDevolucaoAnterior = true
        this.loadingGraficoCompFatAnterior = true
        this.loadingFatAnoAnterior = true
        this.loadingDevAnoAnterior = true
        this.loadingGraficoCompFatAnoAnterior = true
        this.loadingGraficoValorMonetarioDiario = true
        this.loadingValorTendenciaFaturamento = true
        this.loadingDiasPercorrido = true
        this.loadingValorPedidos = true
        this.loadingVolume = true

        this.legendaGrafico = []

        await Comercial.showFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('disable-loading', false)
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('disable-loading', false)
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Comercial.showDevolucao(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.devolucao = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.title = '0,0 %'
            this.text = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            eventEmit.$emit('disable-loading', false)

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucao = false })

        await Comercial.showMeta(this.primeiroDia, this.date, this.select, this.supervisores, localStorage.tokencontrato, this.vendedores).then(resposta => {
          if (resposta.data.status) {
            this.meta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.meta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há meta no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingMeta = false })

        await Comercial.showDadosGraficoMetaMensal(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.titleChartMeta = resposta.data.faturamentoMensal.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart2').getContext('2d')

            this.chartMeta = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.faturamentoMensal, resposta.data.valorMeta],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartMeta,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text
            this.title = '0,0' + '%'
            this.showSnackbar('error', 3000, resposta.data.text)
            if (!this.montarGrafico) {
              this.myChart.destroy()
            }
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.text
            this.title = '0,0' + '%'
            this.showSnackbar('error', 3000, resposta.data.text)

            if (this.myChart.data) {
              this.myChart.destroy()
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Não há meta no período selecionado') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error = e.data.text

            this.title = '0,0' + '%'
          }
        }).finally(f => { this.loadingGraficoMeta = false })

        await Comercial.showDadosGraficoBarrasFaturamentoxMeta(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          this.error = null

          if (resposta.data.status) {
            this.legendaGrafico = [
              { cor: '#ed934f', status: 'Meta Diária' },
              { cor: '#4780b8', status: 'Acima da Meta' },
              { cor: '#cadaed', status: 'Abaixo da Meta' },
            ]

            const ctx = document.getElementById('myChart').getContext('2d')

            this.chartBarLinha = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.diasFaturamento,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoMensal,
                    backgroundColor: resposta.data.colors,
                    order: 2,
                  },
                  {
                    label: 'Meta',
                    data: resposta.data.valorMeta,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return 'Faturamento - ' + tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        return 'Meta - ' + tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingFaturamentoxMeta = false })

        await Comercial.showFaturamentoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoAnterior = false })

        await Comercial.showDevolucaoMesAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucaoMesAnterior = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucaoAnterior = false })

        await Comercial.showDadosGraficoFaturamentoMesAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.titleChartFatxFatAnterior = resposta.data.porcentagemFaturamento.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart3').getContext('2d')

            this.chartFatxFatAnterior = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.porcentagemFaturamento, resposta.data.porcentagemAnterior],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartFatxFatAnterior,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.titleChartFatxFatAnterior = '0,0 %'

            if (this.chartFatxFatAnterior.data) {
              this.chartFatxFatAnterior.destroy()
            }

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoCompFatAnterior = false })

        await Comercial.showFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFatAnoAnterior = false })

        await Comercial.showDevolucaoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucaoMesAnoAnterior = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevAnoAnterior = false })

        await Comercial.showDadosGraficoFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.titleChartFatxFatAnoAnterior = resposta.data.porcentagemFaturamento.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart4').getContext('2d')

            this.chartFatxFatAnoAnterior = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.porcentagemFaturamento, resposta.data.porcentagemAnterior],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 65,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.titleChartFatxFatAnoAnterior,
                    color: '#4780b8',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.titleChartFatxFatAnoAnterior = '0,0 %'

            if (this.chartFatxFatAnoAnterior.data) {
              this.chartFatxFatAnoAnterior.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoCompFatAnoAnterior = false })

        await Comercial.showDadosGraficoBarrasValorMonetario(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart5').getContext('2d')

            this.chartValorMonetario = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês Completo'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = ''

            if (this.chartValorMonetario.data) {
              this.chartValorMonetario.destroy()
            }

            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há meta no mês corrente')
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = ''

            if (this.chartValorMonetario.data) {
              this.chartValorMonetario.destroy()
            }

            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há faturamento no mês corrente')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        await Comercial.showDadosGraficoBarrasValorMonetarioMetaDiario(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart6').getContext('2d')

            this.chartValorMonetarioDiario = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês até hoje'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.chartValorMonetarioDiario.data) {
              this.chartValorMonetarioDiario.destroy()
            }

            this.valorExibicao2 = false
            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.chartValorMonetarioDiario.data) {
              this.chartValorMonetarioDiario.destroy()
            }

            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao2 = false
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoValorMonetarioDiario = false })

        await Comercial.showTendenciaFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não hsá tendência pro mês selecionado') {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValorTendenciaFaturamento = false })

        await Comercial.showDiasFaturamento(this.primeiroDia, this.date, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.diasUteis = resposta.data.diaUtil.toString()
            this.diasPecorrido = resposta.data.diatrabalhados.toString()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDiasPercorrido = false })

        await Comercial.showValorMonetarioPedidosAbertos(this.primeiroDia, this.date, this.select, this.receita, localStorage.tokencontrato, this.supervisores, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorPedidos = resposta.data.pedidosAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValorPedidos = false })

        await Comercial.showValorTotalVolume(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorVolume = resposta.data.kilosFaturado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingVolume = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #componenteFaturamentoAtual {
      margin: 2rem 0 0 0 !important;
    }

    #componenteAnteriores {
      margin: 2rem 0 0 0
    }
  }
</style>

<style lang="sass">

</style>
